import type { NativeStackScreenProps } from "@react-navigation/native-stack";
import { observer } from "mobx-react-lite";
import React from "react";
import { FeedUI } from "../feed/ui/FeedUI";
import BusinessPlanScreen from "./BusinessPlanScreen";

type Props = NativeStackScreenProps<
  ReactNavigation.RootParamList,
  "BusinessHome"
>;

export const BusinessPlanHomeScreen = observer((props: Props) => {
  return (
    <BusinessPlanScreen {...props} showInfo showAvatars>
      <FeedUI businessPlanUid={props.route.params.businessUid} />
    </BusinessPlanScreen>
  );
});

export default BusinessPlanHomeScreen;
